<template>
  <div class="ticket-form-input-container">
    <div  v-for="(input, index) in inputs" :key="index" class=" input-container col-12">
          
            <textInput
              v-if="getInputType(input.name) === 'textInput'"
              :labelKey="input.name"
              :inputId="input.name"
              :pattern="getPattern(input.name)"
              :errorLabelKey="input.name + '-field-not-ok'"
              :maxlength="getInputMaxLength(input.name)"
              :required="input.required"
              :ref="input.name"
              :type="getInputTextType(input.name)"
            />
  
      
            <textArea
              v-if="getInputType(input.name) === 'textArea'"
              :labelKey="input.name"
              :inputId="input.name"
              :pattern="getPattern(input.name)"
              :required="input.required"
              :ref="input.name" 
            >
            </textArea>
      
      
          <datePickerInput v-if="getInputType(input.name) === 'date'" :labelKey="input.name" :inputId="input.name" :required="input.required" :ref="input.name" ></datePickerInput>
     
       
          <selectInput 
             v-if="getInputType(input.name) === 'select'"
            :defaultOptions="getSelectOption(input.name)" 
            :labelKey="input.name" 
            :inputId="input.name" 
            :required="input.required" 
            :errorLabelKey="input.name + '-error'"
            :ref="input.name" ></selectInput>
      
    </div>
    
  </div>
</template>

<script>
import intl from "./intl/intl";
import {nameToInputType,nameToInputPattern, nameToSelectOptions, nameToInputTextMaxLength,nameToInputTextType} from './utils'
import TextInput from "../formInputs/textInput/TextInput.vue"
import TextArea from "../formInputs/textArea/TextArea.vue"
import DatePickerInput from "../formInputs/datePickerInput/DatePickerInput.vue"
import SelectInput from "../formInputs/selectInput/SelectInput.vue"
export default {
  name: "ticketFormInputs",
  components: {
   "textInput": TextInput,
   "textArea": TextArea,
   "datePickerInput": DatePickerInput,
   "selectInput": SelectInput
   
  },

  props: {
      
      answerId: {
        type: Number,
        default: null,
      },
      pattern: {
        type: String,
        default: null,
      },
      answerDetail: {
        type: Object,
        default: null
      }
     
        
  },
  mounted() {
   
  },
  beforeUnmount() {
    
  },
  data: function () {
    return {
      intl: intl,
     // inputs: this.answerDetail && this.answerDetail.answer_show_input ? this.answerDetail.answer_show_input : []
    };
  },
  methods: {
  
    checkFormInputsMessages(){
     
      this.inputs.map((input) => {
        if(this.$refs[input.name] && this.$refs[input.name]["0"] && this.$refs[input.name]["0"].checkMessage){
          this.$refs[input.name]["0"].checkMessage()
        }
      })
    },
    inputOblligatoriOk() {
      
      let inputOk = true
      this.inputs.map((input) => {
        if(input.required && this.$refs[input.name] && this.$refs[input.name]["0"] &&  !this.$refs[input.name]["0"].requiredInputIsOk()){
          inputOk = false
        }
      
      })
      return inputOk
    },
    getInputParams() {
      let params = {}
      this.inputs.map((input) => {
        
        if(this.$refs[input.name] && this.$refs[input.name]["0"] ){
          params[input.name] = this.$refs[input.name]["0"].inputField
        }
        
          
      })
      return params
    },


     getInputType(name) {
       return nameToInputType(name)
    }, 
    getPattern(name) {
       return nameToInputPattern(name)
    
    }, 
    getInputMaxLength(name){
      return nameToInputTextMaxLength(name)
    },
    
    getSelectOption(name){
      return nameToSelectOptions(name)
    },

    getInputTextType(name){
      return nameToInputTextType(name)
    }
               
    
  
    
  },
  watch: {
   

  },
  computed: {
        inputs(){
            return   this.answerDetail && this.answerDetail.answer_show_input ? this.answerDetail.answer_show_input : []
        },
       
    },
  
};
</script>
